export enum LEGAL_PAGE_TYPE {
  Imprint = 'imprint',
  FAQ = 'faq',
  Privacy = 'privacy',
  TermsAndConditions = 'agb',
  TermsOfUse = 'terms_of_use',
  VoucherConditions = 'voucher_conditions',
  TermsAndConditionsFB1 = 'terms_of_participation_fb_1',
  TermsAndConditionsFB2 = 'terms_of_participation_fb_2',
  TermsAndConditionsIG = 'terms_of_participation_ig',
  TermsAndConditionsDP = 'terms_of_participation_dp',
  TermsAndConditionsNPS = 'terms_of_participation_nps',
  TermsAndConditionsTiktok = 'terms_of_participation_TikTok',
  TermsOfUseReviews = 'terms_of_use_reviews',
  GeneralConditionsReverseSupply = 'reverse_supply_agbs',
  Cookies = 'cookies',
  TermsOfUseBestPriceGuarantee = 'TermsOfUseBestPriceGuarantee',
}

export type StaticLegalPageRoutes = Partial<Record<LEGAL_PAGE_TYPE, string>>;
